import { cn } from "@omni/utils/styles";
import { PropsWithChildren } from "react";

import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type HeaderProps = {
    subTitle: string;
};

const Header = ({ subTitle, children }: PropsWithChildren<HeaderProps>) => {
    const { t } = useGranite();
    const { currentStep } = usePaintConfiguratorContext();

    if (!currentStep) return null;

    return (
        <div>
            <p className={cn("tw:text-sm tw:font-light tw:mb-1")}>
                {t("paintConfigurator.step.label")} {currentStep.index + 1}
            </p>
            <p className={cn("tw:text-2xl tw:font-semibold tw:mb-3")}>
                {subTitle}
            </p>
            {children}
        </div>
    );
};

export { Header };
